export default __webpack_public_path__ + "static/media/decor11.8e2946df.webp";